<template>
  <div class="countdown">
    <span v-for="(digit, index) in formattedDays" :key="index" class="digit">
      {{ digit }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    endDate: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      digitStyles: [
        // 初始样式，可以根据需要调整
        { color: "red" },
        { color: "green" },
        { color: "blue" },
        // 继续为其他数字添加样式...
      ],
    };
  },
  computed: {
    remainingDays() {
      const today = Date.now();
      const distance = this.endDate - today;
      return Math.ceil(distance / (1000 * 60 * 60 * 24));
    },
    formattedDays() {
      const days = String(this.remainingDays).padStart(2, "0");
      return days.split("");
    },
  },
};
</script>

<style scoped>
.countdown {
  display: flex;
  align-items: center;
  position: relative;
  left: -4px;
}
.digit {
  width: 20px;
  height: 54px;
  font-size: 38px;
  color: #1d2379;
  font-weight: 600;
  text-align: center;
  line-height: 58px;
  font-family: Montserrat, Montserrat;
}
@media only screen and (max-width: 1450px) {
  .digit {
    font-size: 38px;
  }
}
@media only screen and (max-width: 767px) {
  .countdown {
    left: -2px;
  }
  .digit {
    width: 0.23rem;
    height: 40px;
    line-height: 40px;
    font-size: 0.4rem;
  }
}
</style>